<div id="academy-course" class="page-layout simple left-sidebar inner-scroll">

  <!-- CENTER -->
  <div class="center">

    <!-- CONTENT -->
    <div id="course-content" class="content">

      <!-- ------contenido------ -->
      <div class="page-layout carded fullwidth inner-scroll cursoStep">
        <!-- TOP BACKGROUND -->
        <div class="top-bg"></div>
        <!-- CENTER -->
        <div class="center">
          <!-- CONTENT HEADER -->
          <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">
              <button *ngIf="bypassSS || desdeLanding" mat-icon-button class="mr-16" (click)="regresarDetail()">
                <mat-icon>arrow_back</mat-icon>
              </button>
              <h2 class="m-0">{{'FILEMANAGER.TITULO' | translate}}</h2>
          </div>
          <!-- CONTENT CARD -->
          <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar primary px-24 py-8">
              <span>{{'FILEMANAGER.SUBTI' | translate}}</span>
            </div>
            <!-- CONTENT -->
            <div class="content" fusePerfectScrollbar>

              <div class="course-step-content p-20">


                <ng-container *ngIf="!listadoGPTW">

                  <div *ngIf="!guardandoArchivo" class="uploadfilecontainer" (click)="fileInput.click()" appDropFile
                    (onFileDropped)="uploadFile($event)"
                    [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <input hidden type="file" #fileInput id="inputFile" (change)="onFileChange($event)">
                    <h1>{{'FILEMANAGER.CARGA.TITULO' | translate}}</h1>
                  </div>

                  <div *ngIf="guardandoArchivo" class="mt-20" fxLayout="row" fxLayoutAlign="space-around stretch">
                    <!--- guardando registros en back --->
                    <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
                      [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <h2 class="mt-0">{{'FILEMANAGER.CARGA.CARGANDOTIT' | translate}}</h2>
                      <mat-divider></mat-divider>
                      <div class="mt-20 mb-20">
                        <div class="h4 secondary-text">{{'FILEMANAGER.CARGA.CARGANTOTXT' | translate}}</div>
                        <mat-progress-bar mode="buffer" [value]="progresoCarga" class="barraCarga mt-20"></mat-progress-bar>
                      </div>
                    </div>
                  </div>

                  <!-- <tablaArchivos
                  [listaArchivosEmpresa]="listaArchivosEmpresa"
                  [puedeBorrar]=true
                  [actualizaArchivos] = "eventsSubject.asObservable()"
                  (carpetaAbierta)="setNombreCarpeta($event)"
                  ></tablaArchivos> -->
                  <tablaArchivos
                  [puedeBorrar]=true
                  [actualizaArchivos] = "eventsSubject.asObservable()"
                  [versionLanding] = "versionLanding.asObservable()"
                  [datosEmpresaSS] = "datosEmpresaSS"
                  (carpetaAbierta)="setNombreCarpeta($event)"
                  (enviaIdCarpeta)="setIdCarpetaActual($event)"
                  (direccionActual)="setDireccionActual($event)"
                  (archivoNuevo)="onFileChange($event)"
                  (tipoCloudNuevo)="versionCloudNueva = $event"
                  ></tablaArchivos>

                </ng-container>

                <ng-container *ngIf="listadoGPTW && listaArchivosInstituto">
                  <div class="statusDiv pb-40" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                      <h2>{{'FILEMANAGER.GPTW.TITULO' | translate}}</h2>
                      <mat-icon class="ml-20 s-40">check_circle</mat-icon>
                    </div>
                  </div>
                  <mat-accordion [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                    <ng-container *ngFor="let empresa of listaArchivosInstituto.empresas; index as i">
                      <mat-expansion-panel class="mb-20">

                        <mat-expansion-panel-header class="accent-50">
                          <mat-panel-title>
                            <b>{{empresa.nombreEmpresa}}</b>
                          </mat-panel-title>
                          <mat-panel-description>
                            {{'FILEMANAGER.GPTW.NUMFILES' | translate}}<b>{{empresa.archivos.length}}</b>
                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- <tablaArchivos class="pt-20"
                        [listaArchivosEmpresa]="empresa"
                        [puedeBorrar]=false
                        [actualizaArchivos] = "eventsSubject.asObservable()"
                        ></tablaArchivos> -->

                      </mat-expansion-panel>
                    </ng-container>


                  </mat-accordion>

                </ng-container>

                <!-- <div *ngFor="let archivo of files" class="">
                  <p>{{archivo}}</p>
                </div>

                <div class="mat-elevation-z3 p-20">
                  <div fxLayout="row" fxLayoutAlign="space-between start">
                    <h2><b>Nombre del archivo</b></h2>
                    <h2><b>Fecha de carga</b></h2>
                    <h2><b>Descargar archivo</b></h2>
                  </div>
                  <div *ngFor="let i of numArchivos" fxLayout="row" fxLayoutAlign="space-between start">
                    <h3>Nombre del archivo.jpg</h3>
                    <h3>25-10-2019</h3>
                    <button mat-raised-button color="primary">Descargar archivo</button>
                  </div>
                </div> -->

              </div>

            </div>

          </div>
        </div>
      </div>
      <!-- ------contenido------ -->
    </div>
    <!-- / CONTENT -->

  </div>
  <!-- / CENTER -->

</div>
